import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ApiIntegration } from '../../_services/api.integration';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  tabClicked: string = "";
  invoice: any;
  invoiceData: any = {
    companyName: "",
    ownerName: "",
    email: "",
    mobile: "",
    addressText: "",
    invoiceNum: "",
    invoiceDate: "",
    invoiceType: "",
    paymentStatus: "",
  };
  invoiceLinesVal: any;
  invoices: any;
  checkedList: any;
  invoiceId: number;
  totalAmount: number;
  openPopup: string = "";
  companyName: string = "";
  ownerName: string = "";
  mobile: number;
  email: string = "";
  exampleModalPreview: string = "";
  addressText: string = "";
  errorMessage: string;
  masterSelected: boolean = false;
  previousStatus = '';
  invoiceStatus: any = 'ALL';
  totalRecords: number;
  userDrop2: any = 'ALL';

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private g: Globals, public user: User, private api: ApiIntegration) {
    this.g.page = "Invoices";
    // this.api.getInvoicesList(this.user.accountOwnerId, "PAID", "1").subscribe((data:any)=> {this.invoice= data; }, err=> {console.log(err);});
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      if (this.tabClicked === 'unPaid') {
        // this.invoiceList("UNPAID");
        this.populateTabData('unPaid', "UNPAID");

      } else if (this.tabClicked == 'paid') {
        // this.invoiceList('PAID');
        this.populateTabData('paid', "PAID");

      }
    } else {
      this.populateTabData('all', "ALL");
    }

  }

  populate(orderChange) {
    this.api.getInvoicesList(orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoice = data.invoiceData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  tabChange() {
    this.checkedList = [];

    this.g.loaderDisplay = "display";
  }

  showInvoiceById(invoice) {
    this.g.loaderDisplay = "display";
    //this.openPopup = "modal";
    //this.opensndPopup = "exampleModalPreview";
    this.api.getInvoicesById(invoice.id).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoiceData = data;
      this.invoiceLinesVal = this.invoiceData.invoiceLinesList;
      this.totalAmount = this.invoiceLinesVal.invoiceAmount
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  showInvoiceList() {
    this.g.loaderDisplay = "display";
    this.api.getInvoicesList("WORK_ORDER").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoice = data;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  invoiceList(status) {

    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Invoice Number / Invoice Type'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.invoiceStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.invoiceStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getInvoicesList';
        let query: any = {
          paymentStatus: this.invoiceStatus,
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role == 'DEMO_ACCOUNT') {
          query.accountOwnerId = this.user.accountOwnerId;
        } else {
          apiMethod = 'api/getAllInvoicesByOrgIdAndPaymentStatus/1/' + this.invoiceStatus;
          delete query.paymentStatus;
          delete query.organizationId;
        }
        this.g.loaderDisplay = "display";

        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.invoice = resp.invoiceData;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.invoice.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }


  populateTabData(triggered, invoiceStatus) {
    this.tabClicked = triggered;
    this.invoiceStatus = invoiceStatus;
    if (!this.previousStatus) {
      this.invoiceList(invoiceStatus);
    } else {
      this.rerender();
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  selectInvoice(c) {
    if (!c.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.invoice.length; i++) {
      this.invoice[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.invoice.length; i++) {
      if (this.invoice[i].isSelected) {
        this.checkedList.push(this.invoice[i]['id']);
      }
    }

  }

  resetCheckedList() {
    this.checkedList = [];
    this.errorMessage = '';
  }

  payInvoice(invoice) {
    let i = 0;
    let ohid;
    for (let j of invoice) {
      if (j.isSelected) {
        i = i + 1;
        ohid = j.id;
      }
    }
    ;
    if (i === 1) {
      this.router.navigate(['/admin/paymentProcessing/' + ohid]);
    } else if (i === 0) {
      this.errorMessage = "Please select one invoice to pay";
    } else {
      this.errorMessage = "Can not pay multiple invoices at once. Please select one at a time";
    }
  }
}

